
import SetupSidebar from '@/components/setup/SetupSidebar.vue'

export default {
    components: { SetupSidebar },
    name: 'index',
    middleware: 'userAuth',//中间件页面登录鉴权
    data() {
        return {
            textarea: '',  //反馈
            dialogImageUrl: '',
            dialogVisible: false,
            rendCode: '',   //	上传随机码
            ImageUrl: []    //  图片
        };
    },
    mounted() {
        this.getUserInfo()
    },
    methods: {
        // 上传图片
        handleRemove(file, fileList) {
            console.log(file, fileList);
            if (this.ImageUrl.length <= 3) {
                this.$refs.addImg.parentNode.style.display = 'inline-block'
            }
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        // 上传图片成功
        handleSuccess(response, file, fileList) {
            console.log(fileList);
            this.ImageUrl = fileList
            if (this.ImageUrl.length >= 3) {
                this.$refs.addImg.parentNode.style.display = 'none'
                console.log(this.$refs.addImg);
            }
        },
        // 上传图片限制
        handleBeforeUpload(file) {
            let index = file.name.lastIndexOf(".")
            let extn = file.name.substr(index + 1)
            let isFormat = [
                'png', 'jpg', 'jpeg', 'gif', 'bmp', 'HEIC'
            ].indexOf(extn.toLowerCase()) != -1
            const isLt5M = file.size / 1024 / 1024 < 5
            if (!isFormat) {
                this.$message.error(this.$t('page.UPLOAD_IMAGE_FORMAT_ERROR'));
                return false
            }
            if (!isLt5M) {
                this.$message.error(this.$t('page.UPLOAD_IMAGE_SIZE_5MB'));
                return false
            }
            if (isFormat && isLt5M) {
                // this.dialogVisible = true
            }

        },
        // 获取个人信息
        async getUserInfo() {
            this.ImageUrl = []
            let res = await this.$global.userInfo()
            res.code = '200' ? (this.rendCode = res.data.rand_code) : []
        },
        // 保存修改
        async handleSubmit() {
            if (!this.textarea) {
                this.$message(this.$t('page.PLEASE_ENTER_CONTENT_EXCLAMATION'));
                return
            }
            let img_url = []
            this.ImageUrl.forEach((i) => {
                console.log(i);
                img_url.push(i.response.data)
            })
            let user = { "feedback_value": this.textarea, "feedback_type": "", "img_url": img_url.toString(), "rand_code": this.rendCode }
            let res = await this.$global.settingFeedback(user)
            if (res.code == 200) {
                this.$refs.upload.clearFiles()
                this.ImageUrl = []
                this.textarea = ''
                this.$message({
                    message: 'modify successfully',
                    type: 'success'
                });
            } else {
                this.$message.error(this.$t('page.CHANGE_FAILED'));
            }
        }
    }
    ,

}
